/* Navigation Maison des Nuages (portée depuis Expert Papier Peint) (2026-10-29) — méga-menu ordinateur + tiroir mobile.
   Méga-menu : survol avec délai (ouverture 120 ms, fermeture 220 ms), clic, clavier
   (Entrée/Espace, flèches gauche/droite entre rubriques, flèche bas = 1er lien, Échap ferme
   et rend le focus), clic hors du panneau ou sur le voile = fermeture.
   Tiroir : focus piégé, Échap (retour au niveau 1 puis fermeture), verrou du défilement. */
(() => {
  if (window.__hcNav) return;
  window.__hcNav = true;

  /* ---------- MÉGA-MENU ---------- */
  const nav = document.querySelector('[data-hcn]');
  if (nav) {
    const items = [...nav.querySelectorAll('[data-hcn-item]')];
    const voile = nav.querySelector('[data-hcn-voile]');
    const header = nav.closest('header-component') || nav.closest('header') || document.body;
    let ouvert = null, tOuvre = 0, tFerme = 0;

    const majBas = () => {
      const r = header.getBoundingClientRect();
      nav.style.setProperty('--hcn-bas', Math.max(0, Math.round(r.bottom)) + 'px');
    };
    const btn = it => it.querySelector('[data-hcn-btn]');
    const fermer = (rendreFocus) => {
      clearTimeout(tOuvre); clearTimeout(tFerme);
      if (!ouvert) return;
      const it = ouvert;
      it.classList.remove('is-ouvert');
      btn(it).setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-ouvert');
      ouvert = null;
      if (rendreFocus) btn(it).focus();
    };
    const ouvrir = it => {
      clearTimeout(tOuvre); clearTimeout(tFerme);
      if (ouvert === it) return;
      if (ouvert) { ouvert.classList.remove('is-ouvert'); btn(ouvert).setAttribute('aria-expanded', 'false'); }
      majBas();
      it.classList.add('is-ouvert');
      btn(it).setAttribute('aria-expanded', 'true');
      nav.classList.add('is-ouvert');
      ouvert = it;
    };
    const survol = matchMedia('(hover: hover) and (pointer: fine)');

    items.forEach((it, idx) => {
      const b = btn(it);
      it.addEventListener('mouseenter', () => {
        if (!survol.matches) return;
        clearTimeout(tFerme);
        tOuvre = setTimeout(() => ouvrir(it), ouvert ? 40 : 120);
      });
      it.addEventListener('mouseleave', () => {
        if (!survol.matches) return;
        clearTimeout(tOuvre);
        tFerme = setTimeout(() => { if (ouvert === it) fermer(false); }, 220);
      });
      /* À la souris, le survol a déjà ouvert : le clic confirme au lieu de refermer.
         Au clavier (detail = 0) et au doigt, le clic bascule. */
      b.addEventListener('click', e => {
        if (e.detail > 0 && survol.matches) { ouvrir(it); return; }
        ouvert === it ? fermer(false) : ouvrir(it);
      });
      b.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); ouvrir(it);
          const premier = it.querySelector('[data-hcn-panel] a');
          if (premier) premier.focus();
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const tops = [...nav.querySelectorAll('.hcn__top')];
          const i = tops.indexOf(b);
          const suivant = tops[(i + (e.key === 'ArrowRight' ? 1 : -1) + tops.length) % tops.length];
          suivant.focus();
          if (ouvert) { const li = suivant.closest('[data-hcn-item]'); li ? ouvrir(li) : fermer(false); }
        }
      });
    });

    document.addEventListener('keydown', e => { if (e.key === 'Escape' && ouvert) fermer(true); });
    document.addEventListener('click', e => { if (ouvert && !ouvert.contains(e.target)) fermer(false); });
    nav.addEventListener('focusout', e => {
      if (ouvert && e.relatedTarget && !nav.contains(e.relatedTarget)) fermer(false);
    });
    if (voile) voile.addEventListener('mouseenter', () => { if (survol.matches) { clearTimeout(tOuvre); tFerme = setTimeout(() => fermer(false), 120); } });
    window.addEventListener('scroll', () => { if (ouvert) majBas(); }, { passive: true });
    window.addEventListener('resize', () => { if (ouvert) majBas(); });
  }

  /* ---------- TIROIR MOBILE ---------- */
  const tiroir = document.querySelector('[data-hct]');
  const declencheurs = [...document.querySelectorAll('[data-hct-ouvrir]')];
  if (tiroir && declencheurs.length) {
    const racine = tiroir.querySelector('[data-hct-ecran="0"]');
    let dernier = null, n2 = null;

    const ecranActif = () => n2 || racine;
    const focusables = el => [...el.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')]
      .filter(x => x.offsetParent !== null || x === document.activeElement);

    const ouvrirN2 = (id, opener) => {
      const e = tiroir.querySelector(`[data-hct-ecran="${id}"]`);
      if (!e) return;
      n2 = e; n2.__opener = opener;
      e.removeAttribute('inert');
      racine.setAttribute('inert', '');
      opener.setAttribute('aria-expanded', 'true');
      e.querySelector('.hct__defile').scrollTop = 0;
      tiroir.classList.add('is-n2');
      requestAnimationFrame(() => e.classList.add('is-actif'));
      setTimeout(() => e.querySelector('[data-hct-retour]').focus({ preventScroll: true }), 60);
    };
    const fermerN2 = (focus = true) => {
      if (!n2) return;
      const e = n2, op = e.__opener;
      e.classList.remove('is-actif');
      e.setAttribute('inert', '');
      racine.removeAttribute('inert');
      tiroir.classList.remove('is-n2');
      if (op) { op.setAttribute('aria-expanded', 'false'); if (focus) op.focus({ preventScroll: true }); }
      n2 = null;
    };
    const ouvrir = d => {
      dernier = d;
      tiroir.hidden = false;
      document.documentElement.classList.add('hct-verrou');
      declencheurs.forEach(x => x.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => requestAnimationFrame(() => tiroir.classList.add('is-ouvert')));
      setTimeout(() => racine.querySelector('[data-hct-fermer]').focus({ preventScroll: true }), 80);
    };
    const fermer = () => {
      tiroir.classList.remove('is-ouvert');
      document.documentElement.classList.remove('hct-verrou');
      declencheurs.forEach(x => x.setAttribute('aria-expanded', 'false'));
      setTimeout(() => { fermerN2(false); tiroir.hidden = true; if (dernier) dernier.focus({ preventScroll: true }); }, 300);
    };

    declencheurs.forEach(d => d.addEventListener('click', () => ouvrir(d)));
    tiroir.addEventListener('click', e => {
      const o = e.target.closest('[data-hct-ouvre]');
      if (o) { ouvrirN2(o.dataset.hctOuvre, o); return; }
      if (e.target.closest('[data-hct-retour]')) { fermerN2(); return; }
      if (e.target.closest('[data-hct-fermer]')) { fermer(); return; }
      if (e.target.closest('a[href]')) { setTimeout(fermer, 50); }
    });
    tiroir.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); n2 ? fermerN2() : fermer(); return; }
      if (e.key !== 'Tab') return;
      const f = focusables(ecranActif());
      if (!f.length) return;
      const a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    matchMedia('(width > 1000px)').addEventListener('change', m => { if (m.matches && !tiroir.hidden) fermer(); });
  }
})();
